<template>
  <div class="">
    <div @click="prev" v-if="!atTop" class="h-screen-1/2 xs-hide fixed left-0 right-0 top-0 cursor-n-resize"></div>
    <div @click="advance" class="h-screen-1/2 xs-hide fixed left-0 right-0 bottom-0 cursor-s-resize"></div>

    <div ref="anchors" class="flex flex-wrap mb-24">
      <div v-for="(slide, i) in slides" :key="i" class="sm:w-1/2 lg:w-1/3 2xl:w-1/4 index-slide scroll-mt-10">
        <div class="grid w-full h-full place-items-center aspect-slide overflow-hidden">
          <figure v-if="isPost(slide)" :class="sizing(slide.acf.thumbnail)" class="min-h-0 no-change relative group">
            <responsive-image :src="slide.acf.thumbnail" class="max-w-full max-h-full object-contain"/>
            <figcaption class="sm:absolute bottom-0 left-0 w-full bg-white transition-all md:opacity-0 group-hover:opacity-100 text-sm">
              <p class="mb-0">{{ slide.post_title }}</p>
              <p class="mb-0">{{ dateFormat(slide.post_date) }}</p>
              <div v-html="slide.post_content"></div>
            </figcaption>
            <v-waypoint @waypoint-in="waypointIn(i)" class="waypoint"></v-waypoint>
          </figure>

          <component v-else :is="slide.link ? 'router-link' : 'span'" :to="relLink(slide.link)" :class="sizing(slide.image)" class="min-h-0 no-change relative group text-sm">
            <responsive-image :src="slide.image" class="max-w-full max-h-full object-contain"/>
            <figcaption class="sm:absolute flex justify-between bottom-0 left-0 w-full bg-white transition-all md:opacity-0 group-hover:opacity-100">
              <span>{{ slide.title }}</span>
              <span v-if="slide.link">+</span>
            </figcaption>
            <v-waypoint @waypoint-in="waypointIn(i)" class="waypoint"></v-waypoint>
          </component>
        </div>
      </div>
    </div>

    <!-- <gallery :data="slides" :show-nav="false" :no-caption="true" class="md-hide lg-hide"></gallery> -->

    <div v-if="contact" class="fixed sm-max-width-footer left-0 bottom-0 pt1 p2 line-height-2">
      <p v-text="contact" class="m0 lg:text-xl"></p>
    </div>

    <IntroScreen :page="page"/>
  </div>
</template>

<script>
  import fecha from 'fecha'
  import store from '@/store'
  import Gallery from '@/components/Gallery'
  import IntroScreen from '@/components/IntroScreen'

  export default {
    name: 'index',
    data () {
      return {
        y: 0,
        listener: 0,
        current: 0
      }
    },
    computed: {
      atTop () {
        return this.y < 80
      },
      page () {
        return this.$store.state.pages['home'] || {}
      },
      contact () {
        return this.page.acf && this.page.acf.contact
      },
      news () {
        return this.$store.state.news || []
      },
      slides () {
        if (!this.page.acf) return []

        const list = this.page.acf.slides.slice()
        // distribute news items
        this.news.forEach((n, i) => {
          const idx = i * 5 + 4
          if (idx >= list.length) return
          list.splice(idx, 0, n)
        })
        return list
      },
      anchors () {
        return this.$refs.anchors.children
      }
    },
    methods: {
      dateFormat (d) {
        return fecha.format(new Date(d), 'DD.MM.YYYY')
      },
      sizing (img) {
        if (!img) return ''

        return img.width > img.height ? 'h-auto w-full' : 'h-full w-auto'
      },
      isPost (item) {
        return item.post_type === 'post'
      },
      relLink (str = '') {
        if (typeof str !== 'string') return ''
        return str.replace(window.location.origin, '')
      },
      waypointIn (id) {
        if (id % 3) return
        this.current = id
      },
      prev () {
        for (let i = 0; i < this.anchors.length; i++) {
          if (this.anchors[i].getBoundingClientRect().top > 0) {
            if (i < 4) {
              window.scrollTo({
                top: 0,
                behavior: 'smooth'
              })
              return
            }
            this.anchors[i - 4].scrollIntoView({
              block: 'start',
              behavior: 'smooth'
            })
            return
          }
        }
      },
      advance () {
        const h = window.innerHeight * 0.66
        for (let el of this.anchors) {
          if (el.getBoundingClientRect().top > h) {
            el.scrollIntoView({
              block: 'start',
              behavior: 'smooth'
            })
            return
          }
        }

        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      }
    },
    beforeRouteEnter (_to, _from, next) {
      store.dispatch('loadHomePage').then(() => {
        next()
      })
    },
    mounted () {
      this.listener = window.addEventListener('scroll', () => {
        this.y = window.scrollY
      })
    },
    onUnmounted () {
      window.removeEventListener(this.listener)
    },
    components: { Gallery, IntroScreen }
  }

  // function shuffle (a) {
  //   for (let i = a.length - 1; i > 0; i--) {
  //     const j = Math.floor(Math.random() * (i + 1))
  //     ;[a[i], a[j]] = [a[j], a[i]]
  //   }
  //   return a
  // }
</script>



// WEBPACK FOOTER //
// src/components/Index.vue